// extracted by mini-css-extract-plugin
export default {"root":"PaymentModal_root__0o3QD","trContainer":"PaymentModal_trContainer__Sf6h4","info":"PaymentModal_info__LdZ0I"};